module.exports = __webpack_public_path__ + "static/mac_app_store@2x-e155e2deae35d5b11f8d5cdcb646447a.png";